import { useSSFBehaviors, useURLParameters } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import { OrderStatusEnum, SettingsPageFetchOpenShiftsQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { useLocation } from 'react-router-dom';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { requestOpenShiftsConfig } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/OpenShifts.constants';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';

export const OpenShiftsDataContext = createGQLDataContext<
  SSFBehaviorsContextType<SettingsPageFetchOpenShiftsQuery>
>({} as SSFBehaviorsContextType<SettingsPageFetchOpenShiftsQuery>);

export const OpenShiftsDataProvider: FC = ({ children }) => {
  const [{ positionId }] = useURLParameters<{ positionId: string }>();
  const { pathname } = useLocation();
  const facility_id = Number.parseInt(pathname.split('/')[3]);

  const [values, rest] = useSSFBehaviors(
    requestOpenShiftsConfig({
      positionId: Number(positionId),
      facilityId: facility_id,
      orderFilter: {
        forOrders: {
          withStatus: [OrderStatusEnum.pending],
          withCommunity: [facility_id],
        },
      },
    }),
  );

  const contextValue = useMemo(() => ({ values, ...rest }), [rest, values]);

  return (
    <OpenShiftsDataContext.Provider value={contextValue}>{children}</OpenShiftsDataContext.Provider>
  );
};

export const useOpenShiftsDataContext =
  (): SSFBehaviorsContextType<SettingsPageFetchOpenShiftsQuery> & {
    handleChange: ChangeFunctionType;
    data: SettingsPageFetchOpenShiftsQuery;
  } => useContext(OpenShiftsDataContext);
